
(function ($) {
	if (!String.prototype.trim) {
		(function () {
			// Make sure we trim BOM and NBSP
			var rtrim = /^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g;
			String.prototype.trim = function () {
				return this.replace(rtrim, '');
			};
		})();
	}

	// Ajaxifies the "like" content forms.
	// Ajaxifies the "report" content links.
	$(function () {
		$(document).on('submit', 'form.js-activity-form', function (e) {
			var t = $(this);
			e.preventDefault();

			$.ajax({
				type: t.attr('method'),
				url: t.attr('action'),
				data: t.serialize(),
				dataType: 'html',
				success: function (html) {
					t.replaceWith(html);
				}
			});
		});
	});


	// Handles the dropdowns on the aircraft index page
	$(function () {
		$('[data-multi-options]').each(function () {
			var context = $(this);
			var source = context.find('.js-source');
			var sink = context.find('.js-sink');
			var data = context.data('multiOptions');

			var update = function (t) {
				var val = t.val();
				var found = false;

				sink.find('option').remove();
				sink.append('<option value="">Select Model</select>');

				if (val) {
					for (var x = data.length - 1; x >= 0; x--) {
						if (data[x].value == val) {
							found = true;

							for (var i = 0; i < data[x].children.length; i++) {
								var kid = data[x].children[i];

								var option = $(document.createElement('option'))
									.attr('value', kid.value)
									.text(kid.text);

								sink.append(option);
							}
							break;
						}
					}
				}

				sink.prop('disabled', !found);

				context.find('.selectpicker').selectpicker('refresh');
			};

			source.on('change', function () { update($(this)); });
			update(source);

		});
	});

	// Handles submitting the form on the Maintenance Library page.
	$(function () {
		$('.js-auto-submit').each(function () {
			var context = $(this);
			var dropdown = context.find('.selectpicker');
			dropdown.on('change', function () {
				context.submit();
			});
		});
	});

	// Ajaxify forms and links
	$(function () {
		function bindAjaxify(context) {
			var container = context.closest('.js-ajaxify-root')
			var dropdown = context.find('.selectpicker');

			var onSuccess = function (data) {
				var dom = $(data);
				container.replaceWith(dom);
				dom.find('.selectpicker').selectpicker();
				dom.find('table').table();
				bindAjaxify(dom.find('.js-ajaxify'));
			};

			dropdown.on('change', function () {
				var action = context.attr('action');
				$.ajax({
					url: action,
					data: context.serialize(),
					method: 'GET',
					dataType: 'html'
				}).success(onSuccess);
			});

			var links = container.find('.pagination a, a.js-ajax-link');

			links.on('click', function (e) {
				e.preventDefault();

				var action = $(this).attr('href');
				$.ajax({
					url: action,
					methoth: 'GET',
					dataType: 'html'
				}).success(onSuccess);
			});
		}

		$('.js-ajaxify').each(function () {
			bindAjaxify($(this));
		});
	});

	// Handles link-based autojump select boxes.
	$(function () {
		$('.js-auto-jump').on('change', function (e) {
			var val = $(this).val();
			if (val)
				window.location.assign(val);
		});
	});
})(jQuery);